import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const LoadStagingWizardRoute: RouteType = {
  name: "LoadStagingWizard",
  path: "/workflows/load-staging",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Load Staging & Verification",
      component: () => import("./LoadStagingWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./LoadStagingWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const loadStore = rootStore.loadStore as ServiceStore;
      const trailerLoadsStore = rootStore.trailerLoadsStore as ServiceStore;
      const yardLocationsStore = rootStore.yardLocationsStore as ServiceStore;
      const yardMovementLogsStore = rootStore.yardMovementLogsStore as ServiceStore;
      const panelStore = rootStore.panelStore as ServiceStore;

      await Promise.all([
        loadStore?.find(),
        trailerLoadsStore?.find(),
        yardLocationsStore?.find(),
        yardMovementLogsStore?.find(),
        panelStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for load staging:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).loadStagingWizardStore;
    store?.reset();
  },
};

export default LoadStagingWizardRoute;